<template>
  <span>
  <a class="data-table-action"
     v-if="!object.deleted_at"
     @click="openReceipt"
     v-b-tooltip.hover
     :title="$t('receipt')"
  >
    <PrintSvg/><span class="action-button-mob-title">{{ $t('receipt') }}</span>
  </a>

    <a class="data-table-action"
       v-if="object.paid > 0 && object.cancel == 'N' && !object.deleted_at && !object.parent_advance_id"
       v-b-tooltip.hover
       @click="returnAdvance"
       :title="$t('return')">
    <ReturnSvg/><span class="action-button-mob-title">{{ $t('return') }}</span>
    </a>


    <a class="data-table-action"
       v-if="object.deleted_at"
       :id="`popover-advance-${object.id}`">
    <InfoSvg class="svg-black svg-size-lg"/><span class="action-button-mob-title">{{ $t('deleted') }}</span>
    </a>

    <CustomPopover :target="`popover-advance-${object.id}`"
                   ref="popover"
                   triggers="click"
                   placement="top"
                   :arrow="false"
                   custom-class="record-popover">
      <div>
        <div class="font-weight-bold">{{ $t('deleted') }}:</div>
        <div v-if="object.deleter">{{ object.deleter.full_name }}</div>
        <div class="small text-muted">{{ formatDateTime(object.deleted_at) }}</div>
      </div>
    </CustomPopover>

    </span>

</template>

<script>

import PrintSvg from '@/assets/svg-vue/general/print2.svg'
import JwtService from "@/services/jwt.service"
import { mapState } from "vuex"
import InfoSvg from "@/assets/svg-vue/general/info.svg.vue"
import CustomPopover from "@/components/parts/calendar/CustomPopover.vue"
import { formatDateTime } from "@/extensions/filters/filters"
import ReturnSvg from "@/assets/svg-vue/accounting/back.svg.vue"
import {copyObject} from "@/extensions/prototypes/prototypes"

export default {
  name: "PatientDatatableAdvanceActions",
  components: {
    ReturnSvg,
    CustomPopover, InfoSvg,
    PrintSvg,
    // NoteSvg
  },
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    ...mapState({
      clinic: state => state.auth.clinic
    })
  },
  data() {
    return {
      showReturnModal: false,
    }
  },
  methods: {
    formatDateTime,
    openReceipt() {
      let link = JwtService.getPrintPrelink(this.clinic)
      window.open(link+'/deposit/'+this.object.advance_id, '_blank')
    },
    async returnAdvance() {
      this.$store.commit('setAdvanceForRefill', copyObject(this.object))
      await this.$nextTick()
      this.$bvModal.show('refill-balance-modal')
    },
  }
}
</script>
